// src/app/lib/page-title.ts
//
// Centralized browser-tab title. Default is "Upmode"; inside a view the tab
// reads "{Brand} · {Module} · Upmode" (GitHub-style middot separators) so
// multiple open tabs are distinguishable.
import { FEATURES, MANAGE_ITEMS } from "@/app/components/navigation/nav-config";

// page id -> nav label, derived from the nav config so titles always match the
// sidebar labels (including sub-pages and the manage/admin pages).
const PAGE_TO_MODULE: Record<string, string> = (() => {
  const map: Record<string, string> = {};
  for (const f of FEATURES) {
    map[f.page] = f.label;
    if (f.children) for (const c of f.children) map[c.page] = c.label;
  }
  for (const m of MANAGE_ITEMS) map[m.page] = m.label;
  return map;
})();

export function moduleLabelForPage(page: string | undefined): string | undefined {
  return page ? PAGE_TO_MODULE[page] : undefined;
}

export function setPageTitle(parts: { brand?: string; module?: string }): void {
  const segs: string[] = [];
  if (parts.brand?.trim()) segs.push(parts.brand.trim());
  if (parts.module?.trim()) segs.push(parts.module.trim());
  document.title = segs.length ? `${segs.join(" · ")} · Upmode` : "Upmode";
}
